import * as Immutable from 'seamless-immutable';
import {sortAlphabeticallyByPath} from '../../utils/sortingHelpers';
import {PermissionsResourceTypes} from '../../constants/issues-admin';
import {
  ISSUES_PERMISSIONS_FETCH_START,
  ISSUES_PERMISSIONS_FETCH_API_FULFILLED,
  ISSUES_PERMISSIONS_FETCH_API_REJECTED,
  ISSUES_PERMISSIONS_BULK_CREATE_START,
  ISSUES_PERMISSIONS_BULK_CREATE_API_FULFILLED,
  ISSUES_PERMISSIONS_BULK_CREATE_API_REJECTED,
  ISSUES_PERMISSIONS_UPDATE_START,
  ISSUES_PERMISSIONS_UPDATE_API_FULFILLED,
  ISSUES_PERMISSIONS_UPDATE_API_REJECTED,
  ISSUES_PERMISSIONS_DELETE_START,
  ISSUES_PERMISSIONS_DELETE_API_FULFILLED,
  ISSUES_PERMISSIONS_DELETE_API_REJECTED
} from '../actions';

const initialState = Immutable.from({
  permissions: [],
  isFetching: false,
  fetchError: null,
  createError: null,
  isBulkCreating: false,
  bulkCreateError: null,
  isUpdating: false,
  updateError: null,
  isDeleting: false,
  deleteError: null
});

const sortPermissions = permissions => {
  const adminPermissions = [];
  const nonAdminPermissions = [];

  sortAlphabeticallyByPath(permissions, 'name').forEach(permission => {
    if (permission.isProjectAdmin) {
      adminPermissions.push(permission);
    } else {
      nonAdminPermissions.push(permission);
    }
  });

  return adminPermissions.concat(nonAdminPermissions);
};

const issuesPermissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ISSUES_PERMISSIONS_FETCH_START:
      return state.merge({isFetching: true, fetchError: null});
    case ISSUES_PERMISSIONS_FETCH_API_FULFILLED:
      return state.merge({isFetching: false, permissions: sortPermissions(action.payload)});
    case ISSUES_PERMISSIONS_FETCH_API_REJECTED:
      return state.merge({isFetching: false, fetchError: action});
    case ISSUES_PERMISSIONS_BULK_CREATE_START:
      return state.merge({isBulkCreating: true, bulkCreateError: null});
    case ISSUES_PERMISSIONS_BULK_CREATE_API_FULFILLED: {
      const permissions = action.payload.successPermissions.concat(state.permissions);
      return state.merge({permissions, isBulkCreating: false});
    }
    case ISSUES_PERMISSIONS_BULK_CREATE_API_REJECTED:
      return state.merge({isBulkCreating: false, bulkCreateError: action});

    case ISSUES_PERMISSIONS_UPDATE_START:
      return state.merge({isUpdating: true, updateError: null});
    case ISSUES_PERMISSIONS_UPDATE_API_FULFILLED: {
      const updatedPermission = action.payload;
      const permissionIndex = state.permissions.findIndex(
        permission => permission.subjectId === updatedPermission.subjectId
      );
      const permissions = state.permissions.asMutable();
      permissions.splice(permissionIndex, 1, updatedPermission);
      return state.merge({permissions, isUpdating: false});
    }
    case ISSUES_PERMISSIONS_UPDATE_API_REJECTED:
      return state.merge({isUpdating: false, updateError: action});

    case ISSUES_PERMISSIONS_DELETE_START:
      return state.merge({isDeleting: true, deleteError: null});
    case ISSUES_PERMISSIONS_DELETE_API_FULFILLED: {
      const permissionIdToRemove = action.meta;
      const permissions = state.permissions.filter(
        permission => permission[PermissionsResourceTypes.ISSUES].id !== permissionIdToRemove
      );
      return state.merge({permissions, isDeleting: false});
    }
    case ISSUES_PERMISSIONS_DELETE_API_REJECTED:
      return state.merge({isDeleting: false, deleteError: action});
    default:
      return state;
  }
};

export default issuesPermissionsReducer;
